import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import {
  getStatus,
  getCurrentRate,
  getCurrentVoiceIndex,
  isAltEnabled,
} from "./selectors";
import TTSStatus from "./TTSStatus";

export const sendStatus = createViewerAction(ViewerMethod.TTS_SEND_STATUS);
export const getSettings = createViewerAction(ViewerMethod.TTS_GET_SETTINGS);
export const playFromTop = createViewerAction(ViewerMethod.TTS_PLAY_FROM_TOP);
export const playFromLocation = createViewerAction(
  ViewerMethod.TTS_PLAY_FROM_LOCATION
);
export const playFromCurrentSelection = createViewerAction(
  ViewerMethod.TTS_PLAY_FROM_CURRENT_SELECTION
);
export const enableAltText = createViewerAction(
  ViewerMethod.TTS_ENABLE_ALT_TEXT
);
export const disableAltText = createViewerAction(
  ViewerMethod.TTS_DISABLE_ALT_TEXT
);
export const stop = createViewerAction(ViewerMethod.TTS_STOP);
export const pause = createViewerAction(ViewerMethod.TTS_PAUSE);
export const resume = createViewerAction(ViewerMethod.TTS_RESUME);
export const setVoiceIndex = createViewerAction(
  ViewerMethod.TTS_SET_VOICE_INDEX
);
export const setRate = createViewerAction(ViewerMethod.TTS_SET_RATE);
export const skipForward = createViewerAction(ViewerMethod.TTS_SKIP_FORWARD);
export const skipBack = createViewerAction(ViewerMethod.TTS_SKIP_BACK);
export const fetchVoices = createViewerAction(ViewerMethod.TTS_GET_VOICES);
export const setNoContentMsg = createViewerAction(
  ViewerMethod.TTS_SET_NO_CONTENT_MSG
);

/**
 * Play from top or resume, depending on status
 */
export function play() {
  return function (dispatch, getState) {
    if (getStatus(getState()) === TTSStatus.PAUSED) {
      dispatch(resume());
    } else {
      dispatch(playFromTop());
    }
  };
}

export const applyTTSSettings = () => {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(setRate(getCurrentRate(state)));
    dispatch(setVoiceIndex(getCurrentVoiceIndex(state)));
    if (isAltEnabled(state)) {
      dispatch(enableAltText());
    } else {
      dispatch(disableAltText());
    }
    dispatch(getSettings());
  };
};
